import React from 'react';
import { FlameIcon } from 'lucide-react';
type ScarcityBarProps = {
  tone?: 'light' | 'dark';
};
export function ScarcityBar({
  tone = 'light'
}: ScarcityBarProps) {
  const isDark = tone === 'dark';
  return <div className={`w-full rounded-2xl border p-4 sm:p-5 ${isDark ? 'border-white/15 bg-white/5' : 'border-navy/10 bg-white'}`} data-id="element-49" data-mp="2l3v2qogp2a6w">
      <div className="flex items-center justify-center gap-2" data-id="element-50" data-mp="2q1oavn1k5e9t">
        <FlameIcon className={`h-4 w-4 ${isDark ? 'text-amber-300' : 'text-[#d4453f]'}`} aria-hidden="true" data-id="element-51" data-mp="2b56ycshmttlo" />
        <p className={`text-sm font-bold uppercase tracking-wide ${isDark ? 'text-white' : 'text-navy'}`} data-id="element-52" data-mp="2g74psa06rupp">
          Solo 9 accessi rimasti
        </p>
      </div>

      <div className={`mt-3 h-3 w-full overflow-hidden rounded-full ${isDark ? 'bg-white/15' : 'bg-navy/10'}`} role="progressbar" aria-valuenow={91} aria-valuemin={0} aria-valuemax={100} aria-label="Accessi promozionali già richiesti" data-id="element-53" data-mp="2766hhfipt11b">
        <div className="h-full rounded-full bg-[#d4453f]" style={{
        width: '91%'
      }} data-id="element-54" data-mp="33m3cjccthjh1" />
      </div>

      <p className={`mt-3 text-center text-[13px] leading-relaxed ${isDark ? 'text-white/70' : 'text-navy/70'}`} data-id="element-55" data-mp="2zkhznr0a956u">
        Il <strong className={isDark ? 'text-white' : 'text-navy'} data-id="element-56" data-mp="3dbwpohsly6ne">91%</strong> degli accessi promozionali è già stato
        richiesto. Restano solo <strong className={isDark ? 'text-white' : 'text-navy'} data-id="element-57" data-mp="2knr45stqcdmi">9 posti</strong> al prezzo
        promozionale di €19.
      </p>
    </div>;
}